import { UPDATE_USERINFO } from '../constants/userInfo'

export default function userInfo(state = {}, action) {
    if (action.type === UPDATE_USERINFO) {
        return action.userInfo;
    }
    return state;
}